import type { StoryblokStoryContentResponseV1 } from "@made-people/nestjs-bff-service";

export function getStoryFromGlobalStoryblokStoriesBySlug(
  slug: string,
  globalStoryblokStories?: StoryblokStoryContentResponseV1[],
): StoryblokStoryContentResponseV1["content"] | undefined {
  return globalStoryblokStories?.find(
    (gss: StoryblokStoryContentResponseV1) =>
      gss.lookupConfiguration.lookupType === "slug" &&
      gss.lookupConfiguration.slug === slug,
  )?.content?.[0];
}

export function getStoriesFromGlobalStoryblokStoriesByComponentType(
  componentType: string,
  globalStoryblokStories?: StoryblokStoryContentResponseV1[],
): StoryblokStoryContentResponseV1["content"][] {
  return (globalStoryblokStories ?? [])
    .filter(
      (gss: StoryblokStoryContentResponseV1) =>
        gss.lookupConfiguration.lookupType === "componentType" &&
        gss.lookupConfiguration.componentType === componentType,
    )
    .flatMap((story) => story?.content?.[0])
    .filter(Boolean);
}

export function getMultipleStoriesFromGlobalStoryblokStoriesByComponentType(
  componentType: string,
  globalStoryblokStories?: StoryblokStoryContentResponseV1[],
): StoryblokStoryContentResponseV1["content"][] {
  return (globalStoryblokStories ?? [])
    .filter(
      (gss: StoryblokStoryContentResponseV1) =>
        gss.lookupConfiguration.lookupType === "componentType" &&
        gss.lookupConfiguration.componentType === componentType,
    )
    .flatMap((story) => story?.content)
    .filter(Boolean);
}
